import { useContext } from 'react'

import { MeetingContext } from '../../providers/MeetingProvider'

export function useMeetingContext() {
  const {
    meeting,
    setMeeting,
    attendee,
    setAttendee,
    information,
    setInformation,
    isRedial,
    setIsRedial,
  } = useContext(MeetingContext)
  return {
    meeting,
    setMeeting,
    attendee,
    setAttendee,
    information,
    setInformation,
    isRedial,
    setIsRedial,
  }
}
